export class RequestPasswordReset {
  email = '';
  domain = '';
}
